import React, { useState } from 'react';
import AppleSignin from 'react-apple-signin-auth';
import AppleIcon from '../images/AppleLogo.svg';
import LoginPage from './LoginPage';
import MenuBar from '../components/Menubar';
import {
	Redirect
} from "react-router-dom";

const appleClientId: string = process.env.REACT_APP_APPLE_CLIENT_ID || 'com.yolo.meal';
const appleRedirectURL: string =
  process.env.REACT_APP_APPLE_REDIRECT_URL || 'https://3c46-119-155-28-245.ngrok-free.app';

type Props = {
  user: any;
  showHome: boolean;
  showBack: boolean;
  handleLogin(user: any): void;
  handleBack(): void;
  backgroundImage: boolean;
};

const defaultProps: Props = {
  user: null,
  showHome: true,
  showBack: false,
  handleLogin: () => {},
  handleBack: () => {},
  backgroundImage: true,
};
const authOptions = {
  clientId: appleClientId,
  scope: 'name email',
  redirectURI: appleRedirectURL,
  state: 'state',
  nonce: 'nonce',
  usePopup: true,
};

const UserLoginPage: React.FC<Props> = (props) => {
  const [error, setError] = useState('');
  const [isErrorCleared, setIsErrorCleared] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(false);
  const params = new URLSearchParams(window.location.search);
  const fromAddYolo = params.get("from") === "add-yolo";

  const handleInputChange = (setter) => (e) => {
    setter(e.target.value);
    setIsErrorCleared(true);
  };

  const renderAppleAuthButton = (props: JSX.IntrinsicAttributes & React.ButtonHTMLAttributes<HTMLButtonElement>) => (
    <button {...props}>
      <img
        src={AppleIcon}
        alt="Apple Icon"
        style={{ marginRight: '5px', width: '24px', height: '24px', alignItems: 'center' }}
      />
      Sign in with Apple
    </button>
  );

  const getReferrer = () => {
    var path = window.location.href;
    const arr = path.split('?');
    if (arr.length === 2) {
      const params = arr[1];
      const paramsArr = params.split('=');
      if (paramsArr.length === 2 && paramsArr[0] === 'referrer') {
        return paramsArr[1];
      }
    }
    return '';
  };

  const handleSignInClick = () => {
    if (isLogin) return;

    setIsLogin(true);
    console.log("request gone");
    let data = {
      "password":password,
      "email":email,
      "referer": getReferrer()
    };

    fetch(process.env.REACT_APP_SERVER_URL + '/login', {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
      }),
      body: JSON.stringify(data),
    })
      .then(async (res) => {
        const json = await res.json(); // wait for the JSON body
        return {
          status: res.status,
          result: json,
        };
      })
      .then(({ status, result }) => {
          if(status !== 200){
            setIsLogin(false);
            setError(result.message);
            setIsErrorCleared(false);
            return;
          }
          setIsErrorCleared(false);
          console.log('after successful login ===> ', result);
          props.handleLogin(result);
          let obj = {
            facebookLogin: false,
            appleLogin: false,
            simpleLogin: true
          }
          localStorage.setItem('loginInfo', JSON.stringify(obj));
          setIsLogin(false);
        }
      )
      .catch((err) => {
        setIsLogin(false);
        console.error(err);
      });
  };

  const handleLoginKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSignInClick();
    }
  };

  const handleAppleResponse = (response) => {
    const authorizationInfo = response.authorization;

    let userInfo = response?.user;

    let data = {};

    if (authorizationInfo) {
      if (userInfo) {
        data = { authorization: authorizationInfo, user: userInfo, referrer: 6 };
      } else {
        data = { authorization: authorizationInfo, referrer: 6 };
      }
      fetch(process.env.REACT_APP_SERVER_URL + '/login', {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
        }),

        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then(
          (result) => {
            console.log('after successful login ===> ', result);
            props.handleLogin(result);
            let obj = {
              facebookLogin: false,
              appleLogin: true,
              simpleLogin: false,
            };
            localStorage.setItem('loginInfo', JSON.stringify(obj));
          },
          (error) => {
            setError(error.message);
            console.log(error);
          }
        );
    } else {
      var error = 'Apple Login error';
      if (response.hasOwnProperty('status')) {
        error = response.status;
      }
      setError(error);
    }
  };

  if (props.user.isLogged) {
    const redirectPath = localStorage.getItem("redirectAfterLogin");

    if (redirectPath) {
      console.log("redirecting to:", redirectPath);
      localStorage.removeItem("redirectAfterLogin");
      window.location.replace(redirectPath);
      return null;
    }

    if (fromAddYolo) {
      return <Redirect to="/add-yolo" />;
    }

    if (props.showHome) {
      return <Redirect to="/home" />;
    }

    return null;
  } else {
    return (
      <main className="main-bg">
        <div className="container">
          <MenuBar user={props.user} />
        </div>
        <div className="container">
          <div className="small-container">
            <div className="startpage-content">
              <div className="start-row d-flex full-height align-items-center" style={{ flexDirection: 'column' }}>
                <h1 className="text-center helvetica about-title" style={{ fontSize: '3rem', color: 'black' }}>
                  Welcome Back!
                </h1>
                {error !== '' && !isErrorCleared && (
                  <p
                    style={{
                      color: '#ffffff',
                      fontSize: '14px',
                      marginBottom: '20px',
                      textAlign: 'center',
                      fontFamily: 'sans-serif',
                      backgroundColor: '#FFABAB',
                      padding: '10px',
                      borderRadius: '5px',
                      width: 'fit-content',
                      margin: '0 auto',
                    }}
                  >
                    {error}
                  </p>
                )}
                <input
                  id="user-email"
                  className="field md-filed text-center"
                  placeholder="Enter Email"
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={handleLoginKeyDown}
                  style={{
                    boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px',
                  }}
                />

                <input
                  id="password"
                  className="field md-filed text-center"
                  placeholder="Enter Password"
                  value={isErrorCleared ? password : error ? '' : password}
                  onChange={handleInputChange(setPassword)}
                  onKeyDown={handleLoginKeyDown}
                  style={{
                    boxShadow: 'rgb(149 149 149 / 75%) 0px 8px 12px -5px',
                  }}
                />
                <div
                  className="width-50 width-80"
                  style={{ width: '50%', display: 'flex', justifyContent: 'flex-end', marginTop: '5px' }}
                >
                  <button
                    type="button"
                    style={{
                      background: 'white',
                      border: 'none',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      fontSize: '14px',
                      padding: '5px 10px',
                      marginBottom: '15px',
                      color: '#4b4b4b',
                    }}
                    onClick={() => (window.location.href = '/forgot-password')} // Define this function in your component
                  >
                    Forgot Password?
                  </button>
                </div>
                <input
                  type="button"
                  className="btn-primary"
                  value="Current Members - Log In"
                  onClick={handleSignInClick}
                  disabled={isLogin}
                  style={{
                    backgroundColor: isLogin ? '#ccc' : '',
                    color: isLogin ? '#666' : '',
                    transition: 'all 0.3s ease',
                  }}
                />

                <h3 style={{ color: 'black', margin: '25px 0 15px 0' }}>OR</h3>

                <div className="apple-auth-div">
                  <AppleSignin
                    authOptions={authOptions}
                    uiType="dark"
                    className="apple-auth-btn"
                    buttonExtraChildren="Sign in with Apple"
                    onSuccess={(response: any) => handleAppleResponse(response)}
                    onError={(error: any) => console.error(error)}
                    skipScript={false}
                    render={renderAppleAuthButton}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
};

LoginPage.defaultProps = defaultProps;

export default UserLoginPage;
